import React from 'react';
import FollowedStreamers from './FollowedStreamers';
import { Container } from 'react-bootstrap';

import './MainRoute.css';

export default class MainRoute extends React.Component {

  componentDidMount() {
    document.title = 'Triode Raid Tool';
  }

  render() {
    return (
      <Container fluid>
        <FollowedStreamers />
      </Container>
    )
  }
}